import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  OnDestroy,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MenuItem } from 'primeng-lts/api';
import { EventPopupComponent } from 'src/app/events/components/event-popup/event-popup.component';
import { EventSocketService } from 'src/app/events/services/event-socket.service';
import { PopupContent } from 'src/app/multiview/models/interfaces';
import { LayersService } from 'src/app/multiview/services/layers.service';
import { MultimediaService } from 'src/app/multiview/services/multimedia.service';
import { CarouselComponent } from 'src/app/shared/components/carousel/carousel.component';
import { CarouselService } from 'src/app/shared/services/carousel.service';
import { PanelService } from '../../services/panel.service';
import {
  ConnectionService,
  ConnectionServiceOptions,
  ConnectionServiceOptionsToken,
  ConnectionState,
} from 'ngx-connection-service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';


import { TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from 'src/app/shared/services/configuration.service';
import { FootbarConfig } from 'src/app/shared/models/configuration';

@Component({
  selector: 'app-footbar',
  templateUrl: './footbar.component.html',
  styleUrls: ['./footbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FootbarComponent implements OnInit, OnDestroy {
  config!: FootbarConfig;
  horaLocal: string = '';
  ubicacion: string = 'Desconocida';

  itemsMenu: MenuItem[] = [];
  showScreenRecorder = false;
  showCipiaExample = false;
  showPopupDialog = true;
  showPanel = true;
  currentPanelName = '';
  lastPanelName = '';
  @ViewChild('MapView') mapView!: ElementRef;
  @ViewChild('carousel') carousel!: CarouselComponent;

  /* variables for internet */
  isConnected: boolean = true;
  isConnectionStable: boolean = true;
  disconnectToastId: number | undefined;
  connectionLevel: string = 'no-connection';
  initialCheckDone: boolean = false;
  unstableToastId: number | undefined;
  firstStableConnection: boolean = true;

  status: string = '';
  slideConfig = { slidesToShow: 4, slidesToScroll: 1 };
  constructor(
    private multimediaService: MultimediaService,
    private layersService: LayersService,
    private eventSocketService: EventSocketService,
    private carouselService: CarouselService,
    private panelService: PanelService,
    private connectionService: ConnectionService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private translate : TranslateService,
    private configurationService : ConfigurationService,
  ) {
  }
  private connectionMessage = {
    noInternet: '',
    unstableInternet: '',
    connectedInternet: ''
  };


  private loadTranslate() {
    this.translate.get([
      'CONFIGURATION.CONNECTION.NO_INTERNET',
      'CONFIGURATION.CONNECTION.UNSTABLE_INTERNET',
      'CONFIGURATION.CONNECTION.CONNECTED_INTERNET'
    ]).subscribe(translations => {
      this.connectionMessage.noInternet = translations['CONFIGURATION.CONNECTION.NO_INTERNET'];
      this.connectionMessage.unstableInternet = translations['CONFIGURATION.CONNECTION.UNSTABLE_INTERNET'];
      this.connectionMessage.connectedInternet = translations['CONFIGURATION.CONNECTION.CONNECTED_INTERNET'];
    });

    this.translate.get([
      'MULTIMEDIA.RECORD_SCREEN',
      'MULTIMEDIA.TAKE_SCREENSHOT',
      'MULTIMEDIA.VIDEO_EXAMPLE'
    ]).subscribe(translations => {
      this.itemsMenu = [
        {
          id: '1',
          label: translations['MULTIMEDIA.RECORD_SCREEN'],
          icon: 'pi pi-fw pi-video',
          command: () => {
            this.showScreenRecorder = true;
          },
        },
        {
          id: '2',
          label: translations['MULTIMEDIA.TAKE_SCREENSHOT'],
          icon: 'pi pi-fw pi-camera',
          command: () => {
            this.multimediaService.screenShot(this.mapView.nativeElement);
          },
        },
        {
          id: '3',
          label: translations['MULTIMEDIA.VIDEO_EXAMPLE'],
          icon: 'pi pi-fw pi-video',
          command: () => {
            this.showCipiaExample = true;
          },
        },
      ];
    });

  }
  private intervalId?: any;

  ngOnInit(): void {
    /* creation of code for the internet */
    this.loadTranslate()
    this.translate.onLangChange.subscribe(()=>{
      this.loadTranslate()
    })

    this.configurationService.footbarConfig$.subscribe(cfg => {
      this.config = cfg;
    });

    this.actualizarHora();
    this.intervalId = setInterval(() => {
      this.actualizarHora();
    }, 1000);

    // this.calcularPesoPagina();
    // this.actualizarMemoria();
    // this.getUbicacion();

    this.connectionService
      .monitor()
      .subscribe((currentState: ConnectionState) => {
        const wasConnected = this.isConnected;
        const wasConnectionStable = this.isConnectionStable;

        this.isConnected = currentState.hasNetworkConnection;
        this.isConnectionStable = currentState.hasInternetAccess;

        if (!this.isConnected) {
          this.connectionLevel = 'no-connection';
          if (this.initialCheckDone && !this.disconnectToastId) {
            const toast = this.toastr.error(
              this.connectionMessage.noInternet,
              '',
              {
                timeOut: 0,
                extendedTimeOut: 0,
                closeButton: false,
                tapToDismiss: false,
              }
            );
            this.disconnectToastId = toast.toastId;
          }
          if (this.unstableToastId) {
            this.toastr.clear(this.unstableToastId);
            this.unstableToastId = undefined;
          }
        } else {
          if (this.disconnectToastId) {
            this.toastr.clear(this.disconnectToastId);
            this.disconnectToastId = undefined;
          }

          if (!this.isConnectionStable) {
            this.connectionLevel = 'unstable-connection';
            //this.initialCheckDone
            if (this.initialCheckDone && !this.unstableToastId) {
              const toast = this.toastr.warning(
                this.connectionMessage.unstableInternet,
                '',
                {
                  timeOut: 0,
                  extendedTimeOut: 0,
                  closeButton: false,
                  tapToDismiss: false,
                }
              );
              this.unstableToastId = toast.toastId;
              console.log('JESUS: ', this.unstableToastId);
            }
          } else {
            this.connectionLevel = 'good-connection';
            if (
              this.initialCheckDone &&
              (!wasConnected || !wasConnectionStable) &&
              this.unstableToastId
            ) {
              this.toastr.success(this.connectionMessage.connectedInternet, '', {
                timeOut: 3000,
              });
              if (this.unstableToastId) {
                this.toastr.clear(this.unstableToastId);
                this.unstableToastId = undefined;
              }
            }
            // this.firstStableConnection = false; // Marcar que la primera conexión estable se ha realizado
          }
        }

        this.initialCheckDone = true;
        this.cdr.detectChanges();
      });

    this.connectionService.updateOptions({
      enableHeartbeat: true,
      heartbeatInterval: 15000,
      heartbeatExecutor: (options) =>
        new Observable<any>((subscriber) => {
          const controller = new AbortController();
          const timeout = setTimeout(() => {
            controller.abort();
            subscriber.error(new Error('No Internet Access'));
          }, 3000); // Ajusta el timeout a 3 segundos

          fetch('/assets/wifi.txt', {
            method: 'get',
            signal: controller.signal,
          })
            .then((response) => {
              clearTimeout(timeout);
              if (response.ok) {
                subscriber.next();
                subscriber.complete();
              } else {
                subscriber.error(new Error('No Internet Access'));
              }
            })
            .catch((error) => {
              clearTimeout(timeout);
              subscriber.error(error);
            });
        }),
    });

    this.layersService.initializeServices();

    
    this.eventSocketService.eventPopup.subscribe((data) => {
      //this.onEvent(data);
    });
  }


  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  closeScreenRecorder() {
    this.showScreenRecorder = false;
  }

  onEvent(event: any) {
    console.log('eventssss on event: ', event);
    const auxEvent = {
      id: Date.now().toString(),
      vehicles: [event.tracker],
      event: event.event,
      mapConf: {
        containerId:
          'popup-container-' + event.event.evento_id.toString() + Date.now(),
        maxZoom: 17,
        zoom: 17,
      },
    };
    this.carouselService.add(EventPopupComponent, { configuration: auxEvent });
    this.cdr.detectChanges();
  }

  clearPopups() {
    this.carousel.clearAllPopups();
  }

  trackByFn(index: number, item: any): any {
    return item.id;
  }

  hidePanel() {
    console.log('Ocultar/Mostrar panel');
    if (this.lastPanelName) {
      this.showPanel = !this.showPanel;
    }
    const currentActivePanel = this.panelService.activePanelClass();
    console.log('currentActivePanel', currentActivePanel);
    if (currentActivePanel) {
      this.currentPanelName =
        this.panelService.getComponentNameFromPanelName(currentActivePanel);
      console.log('panelName', this.currentPanelName);
      this.panelService.clickShowPanel(this.currentPanelName);
      this.lastPanelName = this.currentPanelName;
    } else {
      console.log('using LASTPANELNAME');
      this.panelService.clickShowPanel(this.lastPanelName);
    }
    this.cdr.detectChanges();
  }

 getUbicacion() {
  if ('geolocation' in navigator) {
    navigator.geolocation.getCurrentPosition((pos) => {
      const lat = pos.coords.latitude;
      const lon = pos.coords.longitude;

      this.ubicacion = `Lat: ${lat.toFixed(2)}, Lon: ${lon.toFixed(2)}`;
      this.cdr.detectChanges();

    }, (error) => {
      this.ubicacion = 'Permiso denegado o error';
      console.log(error, "foot config")
      this.cdr.detectChanges();
    });
  } else {
    this.ubicacion = 'Geolocalización no soportada';
  }
}

  formatBytes(bytes: number, decimals = 2): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024,
          dm = decimals < 0 ? 0 : decimals,
          sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'],
          i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  private actualizarHora() {
    const ahora = new Date();
    this.horaLocal = ahora.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

}
